import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Text } from "../../DataDisplay/Text/index.js";
import { getBannerStyles } from "./lib.js";
import { AnnouncementBannerMarkdown } from "./view.markdown.js";
function TextView({
  color = "blue",
  text,
  linksAsText,
  uniqueId
}) {
  const styles = getBannerStyles(color);
  return /* @__PURE__ */ jsx(Box, { sx: styles, "data-testid": uniqueId, children: /* @__PURE__ */ jsx(Text, { variant: "t3", children: /* @__PURE__ */ jsx(
    AnnouncementBannerMarkdown,
    {
      text,
      color: styles == null ? void 0 : styles.span.color,
      linksAsText
    }
  ) }) });
}
export {
  TextView
};
